/* Wisselt een losse foto mee wanneer de bezoeker een andere variant kiest.

   De sfeerrijen hadden dit al via kopero-sfeer-variant.js. Zonder dit script
   bleven de twee nieuwere foto's (wat er meekomt, en de sfeerfoto naast het
   onderste bestelblok) op de eerste variant staan terwijl de sfeerrijen
   erboven al meewisselden: dan zie je glad en gehamerd door elkaar op een
   pagina.

   Opzet is bewust simpeler dan bij de sfeerrijen: hier verandert alleen de
   foto en de alt-tekst, geen kop of alinea. Detectie en normalisatie zijn wel
   identiek, zodat beide scripts op precies dezelfde manier op de
   variant-picker reageren.

   5 september 2026: de kaart is nu overal op Nederlandse sleutels gezet en de
   gekozen optiewaarde wordt daar eerst naartoe vertaald. Op de vertaalde
   markten stond in de kaart wel de juiste sleutel, maar had elke ingang
   dezelfde foto: de Liquid die de foto koos vergeleek de vertaalde waarde met
   'gehamerd' en viel dus altijd terug op glad. Zie kopero-uitvoering.

   7 september 2026: dit bestand wordt door twee secties op de productpagina
   binnengehaald (kopero_product_inhoud en bestellen_slot), en het
   handleidingscript zelfs door drie. Een tweede <script src> op dezelfde
   pagina voert het bestand opnieuw uit, en een class op het hoogste niveau
   twee keer declareren is een SyntaxError: die gooide de hele tweede kopie
   weg. Functioneel ging er niets stuk, want de eerste kopie had zijn werk al
   gedaan, maar er stonden wel zeven onopgeloste fouten in de console van elke
   productpagina. De vlag hieronder maakt een tweede uitvoering een lege
   handeling. De secties elk hun eigen script laten laden blijft prima: zo
   hoeft geen enkele sectie te weten of een andere er ook al is. */
if (!window.koperoBeeldVariantGeladen) {
  window.koperoBeeldVariantGeladen = true;

  class KoperoBeeldVariant {
    constructor(root) {
      this.root = root;
      this.img = root.querySelector('img');
      this.productHandle = root.dataset.productHandle;
      this.kaart = this.leesKaart();

      if (!this.img || !Object.keys(this.kaart).length) return;

      document.addEventListener('change', (event) => this.opWijziging(event));
    }

    leesKaart() {
      try {
        return JSON.parse(this.root.querySelector('[data-kopero-beeld-kaart]')?.textContent || '{}');
      } catch (error) {
        console.warn('Kopero beeldvarianten konden niet worden geladen.', error);
        return {};
      }
    }

    normaliseer(waarde = '') {
      return waarde
        .toLocaleLowerCase('nl-NL')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
    }

    canoniek(sleutel) {
      try {
        const el = document.querySelector('[data-kopero-uitvoeringen]');
        if (!el) return sleutel;
        return JSON.parse(el.textContent || '{}')[sleutel] || sleutel;
      } catch (error) {
        return sleutel;
      }
    }

    opWijziging(event) {
      const picker = event.target.closest('variant-selects');
      if (!picker || picker.dataset.productHandle !== this.productHandle) return;

      const gekozen = [...picker.querySelectorAll('fieldset, .product-form__input--dropdown')]
        .map((groep) => groep.querySelector('input:checked, select')?.value)
        .filter(Boolean);

      if (gekozen.length) this.zet(this.canoniek(this.normaliseer(gekozen.join('-'))));
    }

    zet(sleutel) {
      const item = this.kaart[sleutel];
      if (!item) return;
      if (item.src) this.img.src = item.src;
      if (item.alt) this.img.alt = item.alt;
    }
  }

  const initKoperoBeeldVariant = (scope = document) => {
    scope.querySelectorAll('[data-kopero-beeld]:not([data-beeld-initialized])').forEach((root) => {
      root.dataset.beeldInitialized = 'true';
      new KoperoBeeldVariant(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initKoperoBeeldVariant(), { once: true });
  } else {
    initKoperoBeeldVariant();
  }

  document.addEventListener('shopify:section:load', (event) => initKoperoBeeldVariant(event.target));
}
